module.exports = __webpack_public_path__ + "img/pastures_grey_en.46e6d223.svg";